module.exports = __webpack_public_path__ + "static/avatar-mini-ec6cf84b85c8247c734ede95330ea95b.jpg";